import * as apiActions from '@configuratorware/configurator-frontendgui/App/Reducers/Actions';
import { ActionTypes } from './types';
import * as configuratorActions from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import * as uiActions from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';

export const setItems = (payload: object | null) => (dispatch) => {
  dispatch({
    type: ActionTypes.SET_ITEMS,
    payload: payload.data ? payload.data : [],
  });
  dispatch({
    type: configuratorActions.RECEIVE_OPTIONS,
    data: payload.data,
    receivedAt: Date.now(),
  });
};

export const fetchItems = () => (dispatch) => {
  dispatch(apiActions.fetchDataAsync('/items', setItems));
};

export const setSelectedComponentGroup = (payload: object) => ({
  type: ActionTypes.SET_SELECTED_COMPONENT_GROUP,
  payload,
});

export const fetchItemOptionDetails = (itemIdentifier) => {
  return apiActions.fetchDataAsync(
    'configuration/loadbyitemidentifier/' + itemIdentifier,
    (data, extraData, response) => (dispatch) => {
      dispatch(configuratorActions.receiveOptionDetails(data?.item, extraData, response));
    }
  );
};

export const viewOptionDetails = (option) => (dispatch, getState) => {
  if (getState().configurator.itemOptions.some(({ identifier }) => identifier === option.identifier)) {
    const { optiondetails } = getState().configurator;
    if (optiondetails.identifier !== option.identifier) {
      dispatch(fetchItemOptionDetails(option.identifier));
    } else {
      dispatch(uiActions.setVisible('optionDetails', true));
    }
  } else {
    return dispatch(configuratorActions.viewOptionDetails(option));
  }
};

export const selectOption =
  (option, refreshOptionList, showOptionDetails, optionClassification) => (dispatch, getState) => {
    if (getState().configurator.itemOptions.some(({ identifier }) => identifier === option.identifier)) {
      dispatch(configuratorActions.setLoadIdentifier(option.identifier));
      dispatch(configuratorActions.fetchConfiguration(option.identifier));
      dispatch(uiActions.setVisible('optionDetails', false));
    } else {
      return dispatch(
        configuratorActions.selectOption(option, refreshOptionList, showOptionDetails, optionClassification)
      );
    }
  };
